import { render } from "./Suggestions.vue?vue&type=template&id=37723e9a&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"

import "./Suggestions.vue?vue&type=style&index=0&id=37723e9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37723e9a"]])

export default __exports__